import { render, staticRenderFns } from "./api_general_tab.vue?vue&type=template&id=6021df4a&scoped=true&"
import script from "./api_general_tab.vue?vue&type=script&lang=js&"
export * from "./api_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6021df4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6021df4a')) {
      api.createRecord('6021df4a', component.options)
    } else {
      api.reload('6021df4a', component.options)
    }
    module.hot.accept("./api_general_tab.vue?vue&type=template&id=6021df4a&scoped=true&", function () {
      api.rerender('6021df4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/api/location/tabs/api_general_tab.vue"
export default component.exports